import { useSelector } from "@tanstack/react-store"
import { createStore } from "@tanstack/store"

const updateRequiredStore = createStore(false)

export function requireUpdate(): void {
	updateRequiredStore.setState(() => true)
}

export function useUpdateRequired(): boolean {
	return useSelector(updateRequiredStore, (state) => state)
}
